import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { TagType } from 'shared/components/vxl/Tag/Tag';
import { useStatsig } from 'shared/hooks/statsig/useStatsig';
import { FeatureFlagKey } from 'shared/providers/statsig/StatsigProvider.d';

export const useFrozenCardEnabled = () => {
  const { isFeatureEnabled } = useStatsig();

  const isFrozenLanguageEnabled = useMemo(
    () => isFeatureEnabled(FeatureFlagKey.RENAME_LOCK_TO_FROZEN),
    [isFeatureEnabled],
  );

  return isFrozenLanguageEnabled;
};

export const useCardSelectionCardLockExperience = () => {
  const isFrozenLanguageEnabled = useFrozenCardEnabled();

  const { t: translatedText } = useTranslation('cardManagement', {
    keyPrefix: 'cardSelection',
  });

  if (isFrozenLanguageEnabled) {
    return {
      tag: {
        iconKey: 'FREEZE',
        type: TagType.INFO,
        text: translatedText('tag.frozen'),
      },
    };
  }

  return {
    tag: {
      iconKey: 'LOCK_FILLED',
      type: TagType.INFO,
      text: translatedText('tag.locked'),
    },
  };
};

export const useCardManagerCardLockExperience = () => {
  const isFrozenLanguageEnabled = useFrozenCardEnabled();
  const { t: translatedText } = useTranslation('cardManagement', {
    keyPrefix: 'manageCard',
  });

  if (isFrozenLanguageEnabled) {
    return {
      toggle: {
        beforeAction: translatedText('freezeCard.beforeFreeze'),
        afterAction: translatedText('freezeCard.afterFreeze'),
        info: translatedText('freezeCard.info'),
      },
      bottomSheet: {
        wallet: {
          header: translatedText('bottomSheet.wallet.headerTextFrozen'),
          body: translatedText('bottomSheet.wallet.bodyTextFrozen'),
        },
        buttons: {
          enableCard: translatedText('bottomSheet.buttons.unfreezeCard'),
        },
      },
    };
  }

  return {
    toggle: {
      beforeAction: translatedText('lockCard.beforeLock'),
      afterAction: translatedText('lockCard.afterLock'),
      info: translatedText('lockCard.info'),
    },
    bottomSheet: {
      wallet: {
        header: translatedText('bottomSheet.wallet.headerTextLocked'),
        body: translatedText('bottomSheet.wallet.bodyTextLocked'),
      },
      buttons: {
        enableCard: translatedText('bottomSheet.buttons.unlockCard'),
      },
    },
  };
};
